import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

export function isExpired(deadline, whenAsDate = new Date(Date.now())) {
  return new Date(deadline.date) < whenAsDate;
}

export function renderIcon(
  iconColor, iconTitle, title, additionalText = null
) {
  let txtColor = "";
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <FontAwesomeIcon style={{ color: iconColor, margin: "5px" }} icon={["fas", iconTitle]} />
      {additionalText ? (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ color: txtColor }}>
            <FormattedMessage id={title} />
          </div>
          &nbsp;
          <div> {additionalText} </div>
        </div>
      ) : (
        <div style={{ color: txtColor }}>
          <FormattedMessage id={title} />
        </div>
      )}
    </div>
  );
}

export function renderStatus(deadline) {
  let paymentStatus = null;  
  if (!deadline.status?.confirmed) {
    paymentStatus = "-";
  } else if (deadline?.status?.archived) {
    paymentStatus = renderIcon(
      "rgb(253, 185, 39)", "archive", "deadlines.pages.table.archived", null
    );
  } else {
    if (deadline?.payment?.step === "suspended") {
      paymentStatus = renderIcon(
        "rgb(253, 185, 39)", "arrow-circle-right", "deadlines.pages.table.suspended", null
      );
    } else if (deadline?.payment?.step === "authorized") {
      paymentStatus = renderIcon(
        "rgb(253, 185, 39)", "arrow-circle-right", "deadlines.authorized", null
      );
    } else if (deadline?.payment?.step === "rejected") {
      paymentStatus = renderIcon(
        "rgb(216, 40, 41)", "times-circle", "deadlines.notAuthorized", null
      );
    } else if (deadline?.payment?.step === "paid") {
      paymentStatus = renderIcon(
        "rgb(9, 130, 42)", "check-circle", "deadlines.paid", null
      );
    } else if (deadline?.payment?.step === "collected") {
      paymentStatus = renderIcon(
        "rgb(9, 130, 42)", "check-circle", "deadlines.collected", null
      );
    } else if (deadline?.payment?.step === "unpaid") {
      paymentStatus = renderIcon(
        "rgb(216, 40, 41)", "times-circle", "deadlines.pages.table.notPaid", null
      );
    } else if (deadline?.payment?.step === "to_be_paid") {
      paymentStatus = renderIcon(
        "rgb(253, 185, 39)", "arrow-circle-right", "deadlines.pages.table.due", null
      );
    } else if (deadline?.payment?.step === "to_be_collected") {
      paymentStatus = renderIcon(
        "rgb(253, 185, 39)", "arrow-circle-right", "deadlines.pages.table.toCash", null
      );
    } else if (deadline?.payment?.step === "failed") {
      paymentStatus = renderIcon(
        "rgb(253, 185, 39)", "arrow-circle-right", "deadlines.failed", null
      );
    } else if (deadline?.payment?.step === "pending") {
      paymentStatus = renderIcon(
        "rgb(253, 185, 39)", "arrow-circle-right", "deadlines.pages.table.pending", null
      );
    } else if (deadline?.payment?.step === "rebated") {
      paymentStatus = renderIcon(
        "rgb(9, 130, 42)", "check-circle", "deadlines.pages.table.rebated", null
      );
    }
  }
  return <div>{paymentStatus}</div>;
}

export function getFirstDateOfMonth(month, year) {
  const firstDay = new Date(
    year, month, 1
  );
  // Attenzione l'offset va calcolato sulla data in ingresso
  const tzoffset = new Date(
    year, month, 1
  ).getTimezoneOffset() * 60000;
  return new Date(firstDay - tzoffset).toISOString().split("T")[0];
}

export function getLastDateOfMonth(month, year) {  
  const lastDay = new Date(
    parseInt(year), parseInt(month) + 1, 0
  );
  // Attenzione l'offset va calcolato sulla data in ingresso
  const tzoffset = new Date(
    parseInt(year), parseInt(month) + 1, 0
  ).getTimezoneOffset() * 60000;
  return new Date(lastDay - tzoffset).toISOString().split("T")[0];
}